import React, {useState, useRef, useEffect} from 'react';
import ArrBarChartSelectable, {
  BarChartSelectableSeries,
} from '../../../components/common/arr-bar-chart-selectable/ArrBarChartSelectable';

const mockLabels = ['Alpha', 'Beta', 'Gamma', 'Delta'];
const mockSeries: BarChartSelectableSeries[] = [
  {
    label: 'Series 1',
    data: [12, 19, 3, 5],
  },
];

const BarChartSelectableDemo: React.FC = () => {
  const [selectedBars, setSelectedBars] = useState<string[]>([]);
  const lastClickedBar = useRef<{key: string; data: any} | null>(null);

  const handleBarClick = (barKey: string, barData: any) => {
    lastClickedBar.current = {key: barKey, data: barData};
  };

  useEffect(() => {
    if (!lastClickedBar.current) return;

    const selectedLabels = selectedBars.map((key) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [seriesIdx, dataIdx] = key.split('-').map(Number);
      return mockLabels[dataIdx];
    });

    const {key, data} = lastClickedBar.current;
    alert(
      `Bar clicked: ${key} | Label: ${data.label} | Value: ${data.value}\nSelected: ${selectedLabels.join(', ')}`
    );

    lastClickedBar.current = null;
  }, [selectedBars]);

  return (
    <div style={{maxWidth: 600, margin: '0 auto'}}>
      <ArrBarChartSelectable
        labels={mockLabels}
        series={mockSeries}
        xAxisLabel="Category"
        yAxisLabel="Value"
        horizontal={true}
        selectedBars={selectedBars}
        onBarClick={handleBarClick}
        onSelectionChange={setSelectedBars}
        multiSelect={true}
        showLegend={false}
        showSelectAllCheckbox={true}
        dataTestId="bar-chart-selectable-demo"
      />
    </div>
  );
};

export default BarChartSelectableDemo;
